import * as React from "react";
import { Form, Formik } from "formik";
import Panel from "../core/Panel";
import { inviteUser, userValidationSchema } from "../../libs/user";
import TextField, { TextFieldLabel } from "../core/TextField";
import DatePicker from "../core/DatePicker";
import * as moment from "moment";
import Button from "../core/Button";
import toast from "../../utils/toast";
import UserRolesEditor from "../employee/UserRolesEditor";

const emptyUser: Partial<IUserAttributes> = {
  name: "",
  email: "",
  hireDate: moment().format(),
  jobTitle: "",
  roles: [],
};

interface IProps extends IOnboardStepProps {}

interface IState {}

class BulkUserInvite extends React.Component<IProps, IState> {
  state: IState = {};

  componentDidMount() {
    this.props.allowNextStep(true);
    this.props.onBeforeNextStep(() => {
      this.props.setStepComplete();
    });
  }

  render() {
    const { org } = this.props;

    return (
      <>
        <Panel heading={"Invite Employees"} type={"primary"}>
          <p>
            Now, let's invite your employees. The form will reset after each
            user is successfully invited.
          </p>
          <p>
            Proceed to the next step when you're ready. You can always invite
            more people later as well.
          </p>
        </Panel>
        <Panel>
          <Formik
            initialValues={emptyUser}
            onSubmit={async (values, actions) => {
              actions.setSubmitting(true);

              try {
                await inviteUser(values, org.id);
              } catch (e) {
                toast.error("User invite failed.");
                actions.setSubmitting(false);
                return;
              }

              toast.success(`${values.name} invited successfully!`);
              actions.setSubmitting(false);
              actions.setValues(emptyUser);
            }}
            validationSchema={userValidationSchema}
            render={({
              values,
              errors,
              touched,
              handleChange,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <TextField
                  label={"Name"}
                  value={values.name}
                  type={"text"}
                  name={"name"}
                  onChange={handleChange}
                  required={true}
                  error={errors.name}
                />
                <TextField
                  label={"Email"}
                  value={values.email}
                  type={"email"}
                  name={"email"}
                  onChange={handleChange}
                  required={true}
                  error={errors.email}
                />
                <TextField
                  label={"Job Title"}
                  value={values.jobTitle}
                  type={"text"}
                  name={"jobTitle"}
                  onChange={handleChange}
                />
                <TextFieldLabel label="Hire Date" error={errors.hireDate} />
                <DatePicker
                  selected={moment(values.hireDate).toDate()}
                  onChange={mo =>
                    setFieldValue("hireDate", moment(mo).format())
                  }
                />
                <UserRolesEditor
                  roles={values.roles}
                  setRoles={roles => setFieldValue("roles", roles)}
                />
                <p>&nbsp;</p>
                <Button
                  disabled={isSubmitting}
                  type={"submit"}
                  color={"primary"}
                >
                  Invite
                </Button>
              </Form>
            )}
          />
        </Panel>
      </>
    );
  }
}

export default BulkUserInvite;



// WEBPACK FOOTER //
// ./app/javascript/components/onboarding/BulkUserInvite.tsx